/** Hosts a Builder-authored link may send the visitor to (the host itself or any subdomain). */
const ALLOWED_DOMAINS = ["pivothealth.com", "healthcare.com"];

function isAllowedHostname(hostname: string): boolean {
  if (hostname === "localhost") return true;
  return ALLOWED_DOMAINS.some(
    (domain) => hostname === domain || hostname.endsWith(`.${domain}`)
  );
}

/**
 * Guards `location.assign` / `window.open` against open redirects and
 * `javascript:` / `data:` URLs (PPI-1994). Only same-origin paths (`/x`) and
 * http(s) URLs on our own domains qualify; protocol-relative (`//host`) and
 * backslash tricks (`/\host`) do not.
 * @param url - The destination about to be navigated to
 */
export default function isSafeNavigationUrl(url: string): boolean {
  if (url.startsWith("/")) {
    return !url.startsWith("//") && !url.startsWith("/\\");
  }
  try {
    const parsed = new URL(url);
    return (
      (parsed.protocol === "https:" || parsed.protocol === "http:") &&
      isAllowedHostname(parsed.hostname)
    );
  } catch {
    return false;
  }
}
